module.exports = __webpack_public_path__ + "static/media/pt2020.78420759.png";